import { render, staticRenderFns } from "./GlobbingConfigs.vue?vue&type=template&id=33b13658&scoped=true"
import script from "./GlobbingConfigs.vue?vue&type=script&lang=js"
export * from "./GlobbingConfigs.vue?vue&type=script&lang=js"
import style0 from "./GlobbingConfigs.vue?vue&type=style&index=0&id=33b13658&prod&scoped=true&lang=css"
import style1 from "./GlobbingConfigs.vue?vue&type=style&index=1&id=33b13658&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b13658",
  null
  
)

export default component.exports